'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/navigation';
import ContentRecord from './ContentRecord';
import ServiceRecord from '../search/service/ServiceRecord';
import PartyRecord from '../search/party/PartyRecord';
import { getIDType } from '@/lib/utils/commonUtils';
import ViewEJson from '../ViewEJson';
import ViewXML from '../ViewXML';
import Error from '../Error';
import { use } from 'react';
import { array } from "prop-types";
import config from '@/config';

export default function RecordView({ resolvePromise, resolutionId, backTo = "/" }) {
    console.log("backTo", backTo);

    // @ts-ignore
    const { response, request } = use(resolvePromise);
    let [record, setRecord] = useState(null);
    const [showXML, setShowXML] = useState(false);
    const [showJSON, setShowJSON] = useState(false);

    const idType = getIDType(resolutionId);
    const [isError, setIsError] = useState(false);
    let legacyView = config.APP_STAGE_LEGACY_URL;
    let legacyURL = null;
    if (legacyView.indexOf('http') === -1) {
        legacyView = 'https://' + legacyView;
    }
    if (idType === 'content') {
        legacyURL = legacyView + "/view/content?id=" + resolutionId;
    } else if (idType === 'party') {
        legacyURL = legacyView + "/view/party?id=" + resolutionId;
    } else if (idType === 'service') {
        legacyURL = legacyView + "/view/service?id=" + resolutionId;
    } else if (idType === 'shortDoi') {
        legacyURL = legacyView + "/view/shortdoi?id=" + resolutionId;
    }


    useEffect(() => {
        console.log("useEffect", "response", response);
        if (!record && response) {
            if (response.error) {
                setIsError(true);
            } else {
                console.log("useEffect", "response", response);
                if (Array.isArray(response.results)) {
                    setRecord(response.results[0]);
                } else {
                    setRecord(response);
                }

            }
        }
    }, [response]);

    const router = useRouter();
    const goBack = () => {
        console.log(history);
        if (backTo.indexOf("/search/content") > -1) {
            router.back();
        } else {
            router.push("/");
        }
    }

    const handleViewXML = () => {
        setShowXML(!showXML);
    };

    const handleViewJson = () => {
        setShowJSON(!showJSON);
    };

    useEffect(() => {
        setShowXML(false);
        setShowJSON(false);
    }, [resolutionId]);

    if (isError) {
        return (
            <Error>
                <p>Oops, we ran into an issue, please try your search again.</p>
            </Error>
        )
    } else if (record) {
        // @ts-ignore
        // @ts-ignore
        return (
            <div className="record-view animate__animated animate__fadeIn">
                <div className="container">
                    <div className="navigation flex flex-row justify-between">
                        <button
                            type="button"
                            onClick={goBack}
                            className="text-theme-blue flex items-center"
                        >
                            <i className={'mio'}>arrow_back_ios</i>
                            <span
                                className="ml-2">Back to {backTo.indexOf("/search/content") > -1 ? "Search Results" : "Search"}</span>
                        </button>
                        {legacyURL !== null && (<a
                            href={legacyURL}
                            target="_blank"
                            rel="noreferrer"
                            className="text-theme-blue flex items-center"
                        >View Legacy</a>)}
                        <div className="flex flex-row justify-between">
                            <button
                                type="button"
                                onClick={handleViewXML}
                                className="text-theme-blue mr-4 flex items-center hidden"
                            >
                                <i className="mio">code</i>
                                <span className="ml-2">View XML</span>
                            </button>
                            <button
                                type="button"
                                onClick={handleViewJson}
                                className={(showJSON ? 'bg-theme-blue ' : 'text-theme-blue ') + 'p-2 flex items-center rounded'}
                            >
                                <i className="mio">data_object</i>
                                <span className="ml-1">View JSON</span>
                            </button>
                        </div>
                    </div>
                    <div className="code-viewer">
                        {showJSON && (
                            <div className="col-span-3">
                                <h2 className="text-xl font-bold mb-2">JSON Data</h2>
                                <ViewEJson response={response} request={request} />
                            </div>
                        )}
                    </div>
                </div>
                <div className="px-0 md:px-4 container ">
                    <div className="content-record bg-primary-light border border-primary-light rounded mb-4">
                        {(idType === 'content' || idType === "shortDoi") && (
                            <ContentRecord record={record} mode="record" isOpen={true} />
                        )}
                        {idType === 'service' && <ServiceRecord record={response} />}
                        {idType === 'party' && <PartyRecord record={response} />}
                    </div>

                    <div className="flex justify-center p-4">
                        {request && (
                            <span className="ml-2">Proxy Request Time: {request.duration}</span>
                        )}
                    </div>
                </div>

            </div>
        );
    } else {
        return (
            <div className="record-view animate__animated animate__fadeIn">
                <div className="container">
                    <div className="navigation flex flex-row justify-between">
                        <button
                            type="button"
                            onClick={goBack}
                            className="text-theme-blue flex items-center"
                        ></button>
                    </div>
                </div>
            </div>
        )
    }


}


//{showXML && (
//           <div className="col-span-3">
//             <h2 className="text-xl font-bold mb-2">XML Data</h2>
//             <ViewXML />
//           </div>
//         )}